import PropTypes from 'prop-types'
import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import momentTZ from 'moment-timezone'
import { FormGroup, ControlLabel, HelpBlock, Checkbox } from 'react-bootstrap'

const BStrapDateInput = ({
  attr, hideControlLabel, label, record, onChange, disabled = false, showTime = false, validToTime = false, nullHour = false,
  asFilter, placeholderText, minDate, onHeaderCheckedChange, errors, errorsValidation, validationSuccess, attrValue, ...rest
}) => {
  const dateTimeFormat = showTime ? defaultConst.DATE_TIME_FORMAT_FULL : defaultConst.DATE_FORMAT.replace('DD', 'dd')
  const errorText = errors ? errors.get(attr) : undefined
  const validationState = errorText ? 'error' : (validationSuccess ? 'success' : null)
  const formStyle = hideControlLabel ? { marginBottom: '0' } : null

  const recValue = attr && record && record.get(attr)
  const value = (attrValue && moment(attrValue).isValid() &&
    moment(typeof attrValue === 'string' && attrValue.indexOf('T') < 0 ? (attrValue + defaultConst.DATE_TIME_UTC) : attrValue)) ||
    (attr && recValue && moment(recValue).isValid()
      ? moment(typeof recValue === 'string' && recValue.indexOf('T') < 0 ? (recValue + defaultConst.DATE_TIME_UTC) : recValue)
      : undefined)

  const valueError = recValue && (!value || recValue.length < 8 || !moment(recValue).isValid())
  const minDateTime = minDate ? new Date(minDate.year(), minDate.month(), minDate.date(), 0, 0, 0) : ''
  const validToTimes = defaultConst.DATE_VALID_TO_TIME

  let classNames = 'form-control'
  if (validationState || valueError) {
    classNames += ' has-error form-control is-invalid'
  }
  if (!asFilter && disabled) {
    classNames += ' disabled-input-style'
  }

  const dateWithTimeZone = (timeZone, year, month, day, hour, minute, second) => {
    const date = new Date(year, month, day, hour, minute, second)
    const tzDate = new Date(date.toLocaleString('en-US', { timeZone: timeZone }))
    const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }))
    date.setTime(date.getTime() + (utcDate.getTime() - tzDate.getTime()))
    return date
  }

  function handleChange (val) {
    const mValue = !val || !moment(val).isValid() || moment(val).year() > defaultConst.DATE_MAX_YEAR
      ? null
      : moment(val)
    const mHour = nullHour ? 0 : (!value ? (validToTime ? validToTimes[0] : 0) : (mValue ? mValue.hour() : 0))
    const mMin = nullHour ? 0 : (!value ? (validToTime ? validToTimes[1] : 0) : (mValue ? mValue.minute() : 0))
    const mSec = nullHour ? 0 : (!value ? (validToTime ? validToTimes[2] : 0) : (mValue ? mValue.second() : 0))
    const finalValue = mValue
      ? new Date(Date.UTC(mValue.year(), mValue.month(), mValue.date(), mHour, mMin, mSec))
      : null
    onChange(attr, finalValue
      ? (nullHour ? moment(finalValue).utc().format().substring(0, 10) : moment(finalValue).utc().format())
      : null)
  }

  function handleChangeRaw (val) {
    val = val && val.substring(0, showTime ? 19 : 10)
    val = val && val.replace('-0', '-').replace('-0', '-')
    val = val && val.length > 0 && val.replace(/[^0-9-: ]/g, '').replace(/-+/g, '-')
    if (val && moment(val).isValid() && ((minDate && moment(val) < minDate) || moment(val).year() > defaultConst.DATE_MAX_YEAR)) {
      onChange(attr, null)
    } else {
      onChange(attr, val)
    }
  }

  const utcValue = (value && moment(value).isValid() &&
    dateWithTimeZone(
      momentTZ.tz.guess(), value.year(), value.month(), value.date(),
      (value.hour() || 0), (value.minute() || 0), (value.second() || 0)
    )) || null

  return (
    <FormGroup style={formStyle} validationState={validationState || (valueError && 'error')}>
      {hideControlLabel
        ? null
        : <ControlLabel>{label} {dateTimeFormat ? <small> ({dateTimeFormat.toUpperCase()})</small> : ''}
          {'  '}
          {onHeaderCheckedChange && Array.isArray(onHeaderCheckedChange) &&
            onHeaderCheckedChange[0] && onHeaderCheckedChange[1]
            ? <Checkbox
              inline style={{ marginLeft: '5px' }}
              onChange={e => onHeaderCheckedChange[1](attr, e.target.checked)}>
              {onHeaderCheckedChange[0]}
            </Checkbox>
            : null}
        </ControlLabel>
      }
      <DatePicker
        dateFormat={dateTimeFormat}
        dropdownMode='select'
        locale={defaultConst.DATE_LANGUAGE}
        disabled={!asFilter && disabled}
        className={classNames}
        onChange={handleChange}
        onChangeRaw={(event) => handleChangeRaw(event.target.value)}
        peekNextMonth
        placeholderText={placeholderText != null
          ? placeholderText
          : (!asFilter
            ? (!disabled ? 'Click to open the calendar' : '')
            : (attr.indexOf('__to') > 0 ? 'To' : 'From')
          )
        }
        popperPlacement={asFilter ? 'right-start' : undefined}
        selected={utcValue || null}
        showMonthDropdown
        showWeekNumbers
        showYearDropdown
        minDate={minDateTime || ''}
        todayButton={<span>Insert current day <i className='glyphicon glyphicon-check' /></span>}
        showTimeInput={showTime ? true : undefined}
        timeFormat={showTime ? defaultConst.DATE_TIME_ONLY : undefined}
        timeInputLabel={showTime ? 'Select time:' : undefined}
        value={utcValue || null}
        {...rest}
      />
      { (errorText || valueError) &&
        <HelpBlock className='form-group has-danger'>
          {valueError ? <small>Wrong value!</small> : errorText}
        </HelpBlock>
      }
    </FormGroup>
  )
}
BStrapDateInput.propTypes = {
  attr: PropTypes.string.isRequired,
  record: PropTypes.object.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object
}

export default observer(BStrapDateInput)
